import { render, staticRenderFns } from "./CruiseDetails.vue?vue&type=template&id=01d57b54&"
import script from "./CruiseDetails.vue?vue&type=script&lang=js&"
export * from "./CruiseDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports